Ext.define('SA.lq.edit.EditControllerFactory', {
    singleton: true,

    createController({model, editDoneBtnClickHandler}) {
        var headerCmp = this.createHeaderCmp(),
            view = Ext.widget({xtype: 'lq-edit-view', headerCmp}),
            locationRadioList = new SA.lq.edit.LocationRadioList({
                listCmp: view.down('#radiosContainer'),
                createLabelHtml: locationStringId => SA.EditLocationLabel.get(locationStringId)
            }),
            controller = new SA.lq.edit.EditController({
                model: model,

                cmps: {
                    locationRadioList,
                    header: headerCmp,
                    projectView: SA.ProjectView.createHidden(view)
                }
            });

        headerCmp.setDoneBtnClickHandler(editDoneBtnClickHandler);
        locationRadioList.setSelectHandler(locationStringId => controller.onRadioListLocationSelect(locationStringId));

        return controller;
    },

    createHeaderCmp() {
        var cmp = Ext.widget({xtype: 'lq-edit-view-header'});

        cmp.titleCmp = cmp.down('#titleCmp');
        cmp.doneBtn = cmp.down('#doneBtn');
        cmp.messageCmp = cmp.down('#messageCmp');

        return cmp;
    }
});